import React, { Component } from "react";
import { Link } from "react-router-dom";

// svg
import logo from "../../assets/svg/baileson-logo.svg";

// styles
import "./style.scss";

class Header extends Component {
  state = {
    menuOpen: false
  };

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  render() {
    return (
      <header className="header">
        <Link to="/" className="header__logo">
          <img src={logo} alt="Baileson Brewing logo" height="93" />
        </Link>
        <nav className="header__nav">
          <Link to="/beers">Beer</Link>
          <Link to="/taproom">Taproom</Link>
          <Link to="/about">About</Link>
        </nav>

        <button
          className="header--mobile__open heading heading--small orange"
          onClick={this.toggleMenu}
        >
          <p>Menu</p>
        </button>

        <div
          className={`header--mobile ${this.state.menuOpen && "is--active"}`}
        >
          <button className="header--mobile__close" onClick={this.toggleMenu}>
            <p>Close</p>
          </button>
          <div className="header--mobile__bg" />
          <nav className="header--mobile__nav">
            <Link onClick={this.toggleMenu} to="/beers">
              Beer
            </Link>
            <Link onClick={this.toggleMenu} to="/taproom">
              Taproom
            </Link>
            <Link onClick={this.toggleMenu} to="/about">
              About
            </Link>
            <Link onClick={this.toggleMenu} to="/faq">
              FAQs
            </Link>
            <a
              onClick={this.toggleMenu}
              href="https://goo.gl/maps/d5CjPiE8LDC2"
            >
              Directions
            </a>
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js